<template>
  <div>
    <div class="row">
      <div class="col-12">
        <span class="badge bg-warning mr-1">{{ area_permit.coordination == 1 ? 'kizárólagos' : 'részleges' }} engedély</span>
        <span class="badge bg-dark" v-if="permit_statuses">
          {{ permit_statuses.find((ps) => ps.id == area_permit.status).name }}
        </span>
        <button
          v-if="
            ((user.role_id == 5 && task.owner_id == user.id) ||
              (user.role_id == 3 && task.location_leader_id == user.id)) &&
            area_permit.status <= 30
          "
          v-b-modal="'fill_detail_' + area_permit.id"
          class="btn btn-warning float-end mx-1"
          :disabled="task.status < 20"
        >
          <i class="fa fa-edit"></i>
        </button>
        <button
          v-if="
            (user.role_id != 5 || task.owner_id != user.id) &&
            area_permit.status < 30
          "
          class="btn btn-warning float-end mx-1"
          disabled
        >
          Kitöltésre vár
        </button>
        <button
          v-if="
            area_permit.status == 30 &&
            (user.role_id != 3 || task.location_leader_id != user.id)
          "
          class="btn btn-green float-end mx-1"
          disabled
        >
          Területvezetői jóváhagyásra vár
        </button>
        <!-- tv általi jóváhagyás -->
        <button
          v-if="
            area_permit.status == 30 &&
            user.role_id == 3 &&
            task.location_leader_id == user.id
          "
          class="btn btn-green float-end mx-1"
          :disabled="area_permit_accepted"
          v-b-modal="'fill_comment_' + area_permit.id"
        >
          Jóváhagyás
        </button>
        <button
          v-if="area_permit.status == 40 && user.id != task.partner_user_id"
          class="btn btn-green float-end mx-1"
          disabled
        >
          Aláírásra vár
        </button>

        <button
          v-if="area_permit.status == 70 && user.id == task.partner_user_id"
          class="btn btn-success float-end mx-1"
          v-b-modal="'fill_partner_return_' + area_permit.id"
        >
          Visszaadás
        </button>
        <button
          class="btn btn-success float-end mx-1"
          v-if="area_permit.status == 70 && user.id != task.partner_user_id"
          disabled
        >
          Visszaadásra vár
        </button>
        <button
          v-if="
            area_permit.status == 80 &&
            (user.role_id == 5 && task.owner_id == user.id)
          "
          class="btn btn-blue float-end mx-1"
          v-b-modal="'fill_return_' + area_permit.id"
        >
          Átvétel
        </button>
        <button
          class="btn btn-success float-end mx-1"
          v-if="
            area_permit.status == 80 &&
            ((user.role_id == 3 && task.location_leader_id != user.id) ||
              (user.role_id == 5 && task.owner_id != user.id) ||
              ![3, 5].includes(user.role_id))
          "
          disabled
        >
          Átvételre vár
        </button>
        <button
          class="btn btn-success float-end mx-1"
          v-if="
            area_permit.status == 50 &&
            (user.role_id != 5 || task.owner_id != user.id)
          "
          disabled
        >
          Aláírva, nyomtatható
        </button>
        <button
          v-if="
            (area_permit.permits
              .filter((p) => p.local_role == 4)
              .filter((p) => p.user_id == user.id).length > 0 ||
              user.role_id == 1 ||
              user.role_id == 5 ||
              user.id == task.partner_user_id ||
              (task.location_leader_id == user.id && user.role_id == 3)) &&
            area_permit.status >= 50
          "
          class="btn btn-green float-end mx-1"
          @click="pdfButtonHandler(area_permit)"
        >
          <i class="fa fa-print"></i>
        </button>
        <a
          v-if="area_permit.status > 20"
          class="btn btn-success float-end mx-1"
          target="_blank"
          :href="back_url + '/document/view/permit/' + area_permit.id"
          ><i class="fa fa-eye"></i
        ></a>
      </div>
    </div>    
    <div class="row">
      <div class="col-12">
        <h5>Vállalkozó cég: {{ partner.name }}</h5>
      </div>
    </div>
    <div class="row"  v-if="area_permit.coordination != 1">
      <div class="col-12">
        <h5>Összehangolást végző cég: 
          <span v-if="area_permit.coordination_partner_id == null">DDC</span>
          <span v-else>
            {{ partners.find(partner => partner.id == area_permit.coordination_partner_id).name }}
          </span>
        </h5>
      </div>
    </div>
    <h6>
      <template v-if="area_permit.end_date_time">
        <span>
          Érvényesség: {{ getSlicedDate(area_permit.start_date_time) }} -
          {{ getSlicedDate(area_permit.end_date_time) }}
        </span>
        <button
          v-b-modal="'approve_extension_' + area_permit.id"
          v-if="has_unresolved_validity"
          class="btn btn-yellow btn-xs mx-1"
          :disabled="!(user.role_id == 3 && task.location_leader_id == user.id)"
        >
          Aktív meghosszabbítási kérvény
        </button>
        <button
          v-else-if="
            ((user.role_id == 5 && task.owner_id == user.id) ||
              (user.role_id == 3 && task.location_leader_id == user.id)) &&
              diffLessThanThreeDays(area_permit.end_date_time) &&
            area_permit.status < 75
          "
          class="btn btn-indigo btn-xs mx-1"
          v-b-modal="'fill_extension_' + area_permit.id"
        >
          Meghosszabbítás
        </button>
      </template>
    </h6>
    <b-modal
      size="md"
      :id="'approve_extension_' + area_permit.id"
      hide-footer
      @shown="getValidityRecords(area_permit.id)"
    >
      <template slot="modal-header">
        <h4 class="modal-title">
          {{
            permit_types[
              permit_types.map((p) => p.id).indexOf(area_permit.permit_type)
            ].name
          }}
          meghosszabbításai
        </h4>
        <a
          class="btn-close"
          @click="$bvModal.hide('approve_extension_' + area_permit.id)"
        ></a>
      </template>
      <b-container>
        <h5>
          Érvényesség kezdete: {{ getSlicedDate(area_permit.start_date_time) }}
        </h5>
        <Loading
          v-if="!validity_records"
          title="Érvényességi rekordok betöltése"
        ></Loading>
        <div v-else>
          <h5>Érvényességi rekordok:</h5>
          <table class="table">
            <thead>
              <tr>
                <th>Dátum és idő</th>
                <th>Esemény</th>
                <th>Státusz</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v_rec, id) in validity_records" :key="id">
                <td>{{ getSlicedDate(v_rec.end_date_time) }}</td>
                <td>{{ getValidityLabel(v_rec) }}</td>
                <td>
                  <span v-if="v_rec.active == 1" class="badge bg-green"
                    ><i class="fa fa-check-circle"></i> jóváhagyva</span
                  >
                  <span
                    v-else-if="v_rec.deleted_at != null"
                    class="badge bg-danger"
                    ><i class="fa fa-times"></i> elutasítva</span
                  >
                  <div v-else>
                    <button
                      class="btn btn-xs btn-lime mx-1"
                      @click="validityActiveUpdate(v_rec.id, 1)"
                    >
                      Jóváhagyom
                    </button>
                    <button
                      class="btn btn-xs btn-danger mx-1"
                      @click="validityActiveUpdate(v_rec.id, 0)"
                    >
                      Elutasítom
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-container>
    </b-modal>
    <b-modal
      size="md"
      :id="'fill_extension_' + area_permit.id"
      cancel-title="Mégse"
      ok-title="Meghosszabbítás"
      @ok="extendPermit(area_permit.id)"
      @shown="getValidityRecords(area_permit.id)"
    >
      <template slot="modal-header">
        <h4 class="modal-title">
          Munkaterület átadási/átvételi engedély meghosszabbítása
        </h4>
        <a
          class="btn-close"
          @click="$bvModal.hide('fill_extension_' + area_permit.id)"
        ></a>
      </template>
      <b-container>
        <h5>
          Érvényesség kezdete: {{ getSlicedDate(area_permit.start_date_time) }}
        </h5>
        <Loading
          v-if="!validity_records"
          title="Érvényességi rekordok betöltése"
        ></Loading>
        <div v-else>
          <h5>Érvényességi rekordok:</h5>
          <table class="table">
            <thead>
              <tr>
                <th>Dátum és idő</th>
                <th>Esemény</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v_rec, id) in validity_records" :key="id">
                <td>{{ getSlicedDate(v_rec.end_date_time) }}</td>
                <td>{{ getValidityLabel(v_rec) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <label class="form-label"
          >Ez az engedély a következő dátumig érvényes:</label
        >
        <div class="row">
          <div class="col-md-8">
            <div class="form-group mt-2">
              <input
                type="date"
                class="form-control"
                v-model="end_date"
                :min="area_permit.end_date_time | moment('yyyy-MM-DD')"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mt-2">
              <input
                v-if="with_time"
                type="time"
                class="form-control"
                v-model="end_time"
              />
            </div>
          </div>
        </div>
        <div class="form-check mt-2">
          <input
            class="form-check-input"
            :true-value="false"
            :false-value="true"
            type="checkbox"
            v-model="with_time"
            id="with_time_input"
          />
          <label class="form-check-label" for="with_time_input"
            >Egész nap</label
          >
        </div>
      </b-container>
    </b-modal>
    <b-modal
      size="l"
      :id="'fill_return_' + area_permit.id"
      cancel-title="Mégse"
      ok-title="Aláírás"
      @ok="
        movePermitStatus(area_permit, {
          returnyesno: returnyesno,
          final_comment: final_comment,
        })
      "
      :ok-disabled="loading"
    >
      <template slot="modal-header">
        <h4 class="modal-title">{{ area_permit.name }} Átvétel</h4>
        <a
          class="btn-close"
          @click="$bvModal.hide('fill_return_' + area_permit.id)"
        ></a>
      </template>
      <b-container>
        <div class="form-group mb-3">
          <label class="form-label"
            >A munka megfelelőségét leellenőriztem, a mai napon a munkát és
            munkaterületet a Vállalkozó cég vezetőjétől átveszem:</label
          >
          <v-select
            v-model="returnyesno"
            :options="items5.yesno"
            :reduce="(option) => option.value"
            label="name"
            class=""
          >
          </v-select>
        </div>
        <label class="form-label">Megjegyzés:</label>
        <textarea
          cols="30"
          rows="10"
          class="form-control"
          v-model="final_comment"
        ></textarea>
      </b-container>
    </b-modal>
    <b-modal
      size="l"
      :id="'fill_partner_return_' + area_permit.id"
      cancel-title="Mégse"
      ok-title="Aláírás"
      @ok="movePermitStatus(area_permit, { partner_return: partner_return })"
      :ok-disabled="loading"
    >
      <template slot="modal-header">
        <h4 class="modal-title">{{ area_permit.name }} Átadás</h4>
        <a
          class="btn-close"
          @click="$bvModal.hide('fill_partner_return_' + area_permit.id)"
        ></a>
      </template>
      <b-container>
        <p>
          A mai napon a munkaterületet a Megrendelőnek átadom. A gép, gépsor,
          berendezés karbantartását, javítását, nagyjavítását elvégeztük. Az a
          biztonságos és rendeltetésszerű üzemeltetésre alkalmas.
        </p>
        <label class="form-label">Megjegyzés:</label>
        <textarea
          cols="30"
          rows="10"
          class="form-control"
          v-model="partner_return"
        ></textarea>
      </b-container>
    </b-modal>
    <b-modal
      size="l"
      :id="'fill_partner_comment_' + area_permit.id"
      cancel-title="Mégse"
      ok-title="Aláírás"
      @ok="movePermitStatus(area_permit, { partner_comment: partner_comment })"
      :ok-disabled="loading"
    >
      <template slot="modal-header">
        <h4 class="modal-title">{{ area_permit.name }} Aláírás</h4>
        <a
          class="btn-close"
          @click="$bvModal.hide('fill_partner_comment_' + area_permit.id)"
        ></a>
      </template>
      <b-container>
        <p>
          Az üzemvezető és a kapcsolattartó nyilatkozatait, az ismertetésre
          került feltételrendszert és alkalmazandó előírásokat, szabályokat
          megértettem, tudomásul vettem, valamennyi érintett saját
          munkavállalónak és közreműködőnek írásban átadom. A munkaterületet
          munkavégzésre alkalmas állapotban átveszem.
        </p>
        <label class="form-label">Megjegyzés:</label>
        <textarea
          cols="30"
          rows="10"
          class="form-control"
          v-model="partner_comment"
        ></textarea>
      </b-container>
      <template #modal-footer="{ cancel, ok }">
        <div class="row w-100">
          <div class="col">
            <b-button
              class="float-start"
              variant="danger"
              @click="cancel()"
            >
              Mégsem
            </b-button>
          </div>
          <div class="col text-end">
            <button class="btn btn-warning" @click="ok()" :disabled="loading" v-if="user.role_id == 6">
              <span v-if="loading" class="spinner-border spinner-border-sm"></span>
              Aláírás
            </button>
            <PinSignatureSimple v-else
              :user_id="area_permit.permits.find(p => p.local_role == 1).user_id"
              @signed="ok()"
              :hideSignButton="
                false
              "
            >
            </PinSignatureSimple>                    
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      size="l"
      :id="'fill_comment_' + area_permit.id"
      cancel-title="Mégse"
      ok-title="Jóváhagyás"
      @ok="movePermitStatus(area_permit, form_data5)"
      :ok-disabled="loading"
    >
      <template slot="modal-header">
        <h4 class="modal-title">{{ area_permit.name }} Jóváhagyás</h4>
        <a
          class="btn-close"
          @click="$bvModal.hide('fill_comment_' + area_permit.id)"
        ></a>
      </template>
      <b-container>
        <div class="form-group mb-3">
          <label class="form-label">
            A munkaterületen a tevékenység tervezett ideje alatt termelési
            feladat vagy egyéb technológiai szolgáltatási tevékenység történik:
          </label>
          <v-select
            v-model="form_data5.production_on_site"
            :options="items5.yesno"
            :reduce="(option) => option.value"
            label="name"
            class=""
          >
          </v-select>
        </div>
        <div class="form-group mb-3" v-if="form_data5.production_on_site">
          <label class="form-label">Termelési feladatok koordinátora:</label>
          <select class="form-select" v-model="form_data5.location_lead_id">
            <option
              v-for="(worker, id) in ddc_employees"
              :key="id"
              :value="worker.id"
            >
              {{ worker.name }}
            </option>
          </select>
          <label class="form-label">Telefonszáma:</label>
          <input
            type="text"
            class="form-control"
            v-model="form_data5.location_lead_tel"
            :readonly="form_data5.hasPhone"
          />
        </div>
        <div class="form-group mb-3">
          <label class="form-label">Megjegyzés/speciális tudnivalók:</label>
          <textarea
            class="form-control"
            cols="30"
            rows="10"
            v-model="form_data5.special_comment"
          ></textarea>
        </div>
      </b-container>
    </b-modal>
    <b-modal
      size="xl"
      :id="'fill_detail_' + area_permit.id"
      cancel-title="Mégse"
      ok-title="Mentés"
      @ok="sendPermit5"
    >
      <template slot="modal-header">
        <h4 class="modal-title">Terület átadási/átvételi engedély kitöltése</h4>
        <a
          class="btn-close"
          @click="$bvModal.hide('fill_detail_' + area_permit.id)"
        ></a>
      </template>
      <b-container>
        <component
          v-bind:is="'PermitForm5'"
          :task="task"
          :permit_type="area_permit"
          :ref="'permit_form_' + area_permit.id"
          @closemodal="closeModal('fill_detail_' + area_permit.id)"
          @loadingstop="loading = false"
        ></component>
      </b-container>
    </b-modal>
    <table class="table table-hover" v-if="area_permit.status != 90">
      <tbody>
        <tr v-for="(task_permit, id) in area_permit.permits" :key="id">
          <td>
            <span>{{
              users.find((u) => u.id == task_permit.user_id).name
            }}</span
            ><span class="mx-2 badge bg-dark" v-if="task_permit.local_role == 4"
              >összehangoló</span
            >
          </td>
          <td class="text-end">
            {{ task_permit.status }}
            
            <!-- vcv aláírása -->
            <button
              v-if="
                area_permit.status == 40 &&
                ((user.id == task.partner_user_id &&
                task_permit.user_id == user.id &&
                !task_permit.signed_at &&
                task_permit.local_role != 4) || (
                  ((user.role_id == 3 && user.id == task.location_leader_id) || (user.role_id == 5 && task.owner_id == user.id)) &&
                  !task_permit.signed_at && 
                  task_permit.local_role != 4
                ))
              "
              class="btn btn-warning float-end"
              v-b-modal="'fill_partner_comment_' + area_permit.id"
            >
              Aláírás <i class="fa fa-signature"></i>
            </button>
            <span
              class="badge bg-green"
              v-else-if="area_permit.status >= 40 && task_permit.signed_at"
            >
              Aláírva {{ getSlicedDate(task_permit.signed_at) }}
            </span>
            <!-- összehangoló aláírása -->             
            <button
              v-if="
                area_permit.status == 40 &&
                user.id == area_permit.coordination_user_id &&
                task_permit.user_id == user.id &&
                !task_permit.signed_at &&
                task.partner_user_id != area_permit.coordination_user_id
              "
              :disabled="signingInProgress"
              class="btn btn-green float-end mx-1"
              @click="signByCoordination(area_permit.id)"
            >
              Aláírás
            </button>
            <PinSignatureSimple v-else-if="area_permit.status == 40 &&
                ((user.role_id == 3 && user.id == task.location_leader_id) || (user.role_id == 5 && task.owner_id == user.id)) && 
                task_permit.local_role == 4 &&
                !task_permit.signed_at && 
                area_permit.permits.find((p) => p.local_role == 1).user_id != area_permit.coordination_user_id"
              :user_id="area_permit.coordination_user_id"
              @signed="signByCoordination(area_permit.id)"
              :hideSignButton="
                !area_permit.permits.find((p) => p.local_role == 4).user_has_pin
              "
            >
            </PinSignatureSimple> 
          </td>
        </tr>
      </tbody>
    </table>    
    <h3 v-else>
      <i class="fa fa-check-circle text-green"></i> Engedély visszahozva
    </h3>
    <!-- external permits -->
    <div
      v-if="area_permit.status != 90 && area_permit_external_permits.length > 0"
    >
      <div class="row">
        <div class="col-12">
          <h4>
            {{ users.find((u) => u.id == task.partner_user_id)?.name || "N/A" }}
            által feltöltendő engedélyek
          </h4>
        </div>
      </div>
      <div
        class="row mt-4"
        v-for="permit in area_permit_external_permits"
        :key="'group-' + permit.id"
      >
        <div class="col-6 d-flex align-items-center">
          <h5>
            {{ getExternalPermitDetails(permit.external_permit_id).name }}
            <span class="d-block fs-10px">
              <a
                v-if="
                  getExternalPermitDetails(permit.external_permit_id).fileLink
                "
                :href="
                  getExternalPermitDetails(permit.external_permit_id).fileLink
                "
              >
                {{
                  getExternalPermitDetails(permit.external_permit_id).linkText
                }}
              </a>
            </span>
          </h5>
        </div>
        <div class="col-6">
          <FileUpload
            model_name="external_task_permit"
            :model_id="permit.id"
            @upload="reloadExternalPermits"
            v-if="task.partner_user_id == user.id"
          ></FileUpload>
        </div>
        <div
          class="col-12 mt-2"
          v-for="permit_file in permit.media"
          :key="permit_file.id"
        >
          <div class="row">
            <div class="col-2">
              <a
                :href="permit_file.original_url"
                target="_blank"
                class="btn btn-success btn-xs"
                title="letöltés"
                download
              >
                <i class="fa fa-download"></i>
              </a>
              <button
                class="btn btn-danger btn-xs mx-2 me-2"
                title="Fájl törlése"
                @click="deleteExternalPermitFile(permit.id, permit_file.id)"
                v-if="task.partner_user_id == user.id"
              >
                <i class="fa fa-trash" v-if="!external_loading"></i>
                <i class="fa fa-spinner fa-spin" v-else></i>
              </button>
            </div>
            <div class="col-10">
              {{ permit_file.file_name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../../../components/Loading";
import PinSignatureSimple from "../../../components/PinSignatureSimple";
import moment from "moment";
import Validity from "../../../apis/Validity";
import Task from "../../../apis/Task";
import PermitForm5 from "@/components/permit-forms/PermitForm5";
import FileUpload from "@/components/FileUpload";
import ExternalTaskPermit from "../../../apis/ExternalTaskPermit";

export default {
  components: {
    PinSignatureSimple,
    PermitForm5,
    Loading,
    FileUpload,
  },
  props: ["task", "area_permit", "partner", "users", "ddc_employees","partners"],
  data() {
    return {
      back_url: false,
      permit_statuses: false,
      permit_types: false,
      validity_records: false,
      end_date: null,
      end_time: null,
      with_time: false,
      returnyesno: true,
      final_comment: null,
      loading: false,
      items5: false,
      partner_comment: null,
      partner_return: null,
      form_data5: {
        production_on_site: false,
        location_lead_id: null,
        location_lead_tel: null,
        special_comment: null,
      },
      area_permit_accepted: false, //TODO felülvizsgálni majd
      has_unresolved_validity: this.area_permit.has_unresolved_validity,
      area_permit_external_permits: this.area_permit.external_permits,
      external_permits: [],
      external_loading: false,
      signingInProgress: false,
    };
  },
  watch: {
    "form_data5.location_lead_id": {
      handler(newVal) {
        if (newVal) {
          let user = (this.form_data5.location_lead_tel = this.users.find(
            (user) => user.id == newVal
          ));
          if (user.phone) {
            this.form_data5.location_lead_tel = user.phone;
            this.form_data5.hasPhone = true;
          } else {
            this.form_data5.location_lead_tel = null;
            this.form_data5.hasPhone = false;
          }
        }
      },
    },
  },
  mounted() {
    this.back_url = process.env.VUE_APP_BACK_URL;
  },
  created() {
    this.permit_statuses = JSON.parse(
      localStorage.getItem("constants")
    ).permit_status;
    this.permit_types = this.permit_types = JSON.parse(
      localStorage.getItem("constants")
    ).permit_types;
    this.external_permits = JSON.parse(
      localStorage.getItem("constants")
    ).external_permits;
    this.items5 = JSON.parse(
      localStorage.getItem("constants")
    ).permit_types.find((pt) => pt.id == 5).items;
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    getSlicedDate(datetime) {
      let m = moment(datetime);
      if (
        (m.hour() == 0 && m.minute() == 0) ||
        (m.hour() == 23 && m.minute() == 59)
      ) {
        return m.format("yyyy-MM-DD");
      } else {
        return m.format("yyyy-MM-DD HH:mm");
      }
    },
    getValidityLabel(v_rec) {
      if (v_rec.active == 1) {
        return v_rec.end_date_time == this.area_permit.end_date_time
          ? "érvényesség vége"
          : "meghosszabbítva";
      } else {
        return "elutasítva";
      }
    },
    diffLessThanThreeDays(datetime) {
      return moment.duration(moment(datetime).diff(moment())).asHours() <= 72;
    },
    validityActiveUpdate(validity_id, active_val) {
      Validity.validityActiveUpdate(validity_id, { active: active_val })
        .then((response) => {
          this.validity_records = response.data;
        })
        .finally(() => {
          this.has_unresolved_validity = false;
        });
    },
    getValidityRecords(id) {
      this.validity_records = false;
      Task.getTaskPermitTypeValidityRecords(this.task.id, id).then(
        (response) => {
          this.validity_records = response.data;
        }
      );
    },
    movePermitStatus(area_permit, data) {
      this.loading = true;
      this.area_permit_accepted = true;

      Task.movePermitStatus(area_permit.id, data)
        .then(() => {})
        .catch(() => {
          this.area_permit_accepted = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    sendPermit5(vbModalEvt) {
      if (vbModalEvt) {
        vbModalEvt.preventDefault();
      }
      this.$refs["permit_form_" + this.area_permit.id].sendFormData();
    },
    closeModal(modal_name) {
      this.loading = false;
      this.$bvModal.hide(modal_name);
    },
    pdfButtonHandler(area_permit) {
      window.open(
        this.back_url + "/document/pdf/permit/" + area_permit.id,
        "_blank"
      );
    },
    extendPermit(id) {
      let end_date_time = this.end_date
        ? moment(
            this.end_date +
              (this.end_time && this.with_time ? " " + this.end_time : " 23:59")
          )
            .tz("Europe/Budapest")
            .format()
        : this.end_date;
      Task.permitExtend(this.task.id, id, {
        end_date_time: end_date_time,
      }).then(() => {
        this.has_unresolved_validity = true;
      });
    },
    setSigned(task_permit, event) {
      this.$set(task_permit, "signed_at", event.signed_at);
    },
    addExternalPermitFile(permit_id) {
      this.external_loading = true;
      ExternalTaskPermit.store(permit_id)
        .then((response) => {
          this.area_permit_external_permits = response.data.external_permits;
        })
        .finally(() => {
          this.external_loading = false;
        });
    },
    deleteExternalPermitFile(permit_id, file_id) {
      this.external_loading = true;
      ExternalTaskPermit.deleteFile(permit_id, file_id)
        .then((response) => {
          this.area_permit_external_permits = response.data.external_permits;
        })
        .finally(() => {
          this.external_loading = false;
        });
    },
    reloadExternalPermits() {
      ExternalTaskPermit.show(this.area_permit.id).then((response) => {
        this.area_permit_external_permits = response.data.external_permits;
      });
    },
    signByCoordination(area_permit_id) {
      this.signingInProgress = true;
      Task.signByCoordination({ area_permit_id: area_permit_id }).finally(
        () => {
          this.signingInProgress = false;
        }
      );
    },
    getExternalPermitDetails(externalPermitId) {
      const externalPermit = this.external_permits.find(
        (p) => p.id === externalPermitId
      );
      return {
        name: externalPermit?.name || "N/A",
        fileLink: externalPermit?.file || null,
        linkText: externalPermit?.link_text || "",
      };
    },
  },
};
</script>

<style>
.table tr {
  border-top: 0px solid !important;
}
</style>
